import {useNavigate, useSearchParams} from "react-router-dom";
import {useState} from "react";
import Status from "../components/status";
import notFoundIcon from "../icons/notfound.svg"

export default () => {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams();
    return <div className={"page"} style={{height: "calc(100vh - 32px)"}}>
        <Status
            icon={notFoundIcon}
            title={"Не удалось провести операцию"}
            subtitle={"Повторите попытку позже"}/>
    </div>
}